
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","fill-rule":"evenodd","d":"M18 22H5.991a2 2 0 01-1.99-2l.01-16a2 2 0 011.99-2h7.17c.53 0 1.037.213 1.409.59l4.83 4.83c.378.372.59.88.59 1.41V20a2 2 0 01-2 2zM8 17a1 1 0 000 2h8a1 1 0 000-2H8zm0-4a1 1 0 000 2h3a1 1 0 000-2H8zm5-9.5V8a1 1 0 001 1h4.5L13 3.5z"}})])
          )
        }
      }
    